import { AppWrapper } from 'components/AppWrapper';
import { SurveyList } from 'components/SurveyList';

import { AccountOptions } from './AccountOptions';
import { ResponsiveRender } from 'components/Blocks';

/**
 * This this on next iteration of the page
 */
export function AccountPage() {
  return (
    <ResponsiveRender
      defaultContent={
        <AppWrapper leftContent={<AccountOptions />}>
          <SurveyList />
        </AppWrapper>
      }
      responsiveContent={
        <AppWrapper leftContent={<AccountOptions />} leftContentOnMobile="bottom">
          <></>
        </AppWrapper>
      }
    />
  );
}
